import { useDispatch, useSelector } from 'react-redux';
import { useEffect } from 'react';
import PropTypes from 'prop-types';
import { CircularProgress } from '@material-ui/core';
import { useRouter } from 'next/router';
import {
  getBrochureRequest,
} from '../../store/slices/brochure';
import { SearchStatus } from '../../constants';
import withSpinner from '../../HOCs/withSpinner';
import Trip from './Trip';
import EmailToClientDetails from '../EmailToClientForm/EmailToClientDetails';
import ModalSpinnerSaveTrip from '../ModalSpinner/ModalSpinnerSaveTrip';
import TipTapEditor from '../EmailToClientForm/TipTapEditor';
import { showSpinner, richTextButtonStyles } from '../EmailToClientForm';

const Brochure = ({ id }) => {
  const dispatch = useDispatch();
  const router = useRouter();
  const { getBrochureStatus, getBrochureError } = useSelector(
    (store) => store.brochure,
  );
  const { sendBrochureRequestStatus } = useSelector((state) => state.brochure.brochure);
  const brochure = useSelector((state) => state.brochure.brochures[id]);
  const { travelAgency, isLoggedIn } = useSelector((state) => state.user);
  const isBrochurePage = router.pathname.indexOf('brochure') > -1;

  const brochureSettings = (travelAgency && travelAgency.settings
    && travelAgency.settings.brochureSettings) || {};
  const {
    pageHeading, pageSubHeading, DisplayName, doHideMessageBoxInPage, doShowBrochureEditor,
  } = brochureSettings;
  const displayLabel = DisplayName?.toLowerCase() || 'Brochure';
  const { isSaveBrochureContent } = useSelector((store) => store.brochure.brochure);
  useEffect(() => {
    if (!brochure && getBrochureStatus === SearchStatus.INITIAL) {
      dispatch(getBrochureRequest({ id }));
    }
  }, [brochure, id, dispatch, getBrochureStatus]);

  if (!brochure) {
    if (getBrochureError && getBrochureStatus === SearchStatus.DONE) {
      return (
        <div className="text-center py-20 text-xl">
          Error:
          {' '}
          {getBrochureError}
        </div>
      );
    }
  }

  const renderComponent = () => (
    <div>
      {brochure && (
        <div className="mx-auto flex justify-between w-85 grid grid-cols-3 gap-4">
          <EmailToClientDetails
            isSavedToDatabase={brochure.isSavedToDatabase}
            createdFor={brochure.createdFor}
            fromEmail={brochure.fromEmail}
            emailRecipients={brochure.emailRecipients}
            emailSubject={brochure.emailSubject}
            emailMessage={brochure.emailMessage}
            headerPrefix={`${displayLabel.charAt(0).toUpperCase() + displayLabel.slice(1)} for`}
            brochureId={brochure.id}
            pageHeading={pageHeading}
            pageSubHeading={pageSubHeading}
            doHideMessageBoxInPage={doHideMessageBoxInPage}
          />
          {brochure && brochure.id && !!Object.keys(brochure.trips).length && brochure.editorJSON
          && isBrochurePage && doShowBrochureEditor
          && (
          <div className="inline-block w-full col-span-3 bg-white rounded sm:p-5 p-2 text-sm sm:text-base">
            <TipTapEditor
              brochure={brochure}
              isEditable={isLoggedIn}
              isBrochurePage={isBrochurePage}
              showSpinner={showSpinner}
              richTextButtonStyles={richTextButtonStyles}
            />
          </div>
          )}
          <div className="inline-block w-full col-span-3">
            <p className="sm:text-2xl text-xl sm:pl-0 pl-2 font-bold">{brochure.trips.length > 1 ? `Your ${displayLabel} options:` : `Your ${displayLabel} option:`}</p>
            {isBrochurePage ? (
              <>
                {sendBrochureRequestStatus === SearchStatus.INITIAL && (
                  <div className="w-full flex justify-center items-center">
                    <CircularProgress />
                    <div className="ml-2">
                      Please wait,
                      {' '}
                      {isSaveBrochureContent ? 'saving' : 'removing'}
                      ...
                    </div>
                  </div>
                )}
                {sendBrochureRequestStatus !== SearchStatus.INITIAL
                    && brochure.trips.length > 0 && (
                  brochure.trips.map((trip) => (
                    <div key={`trip-${trip.longTripTitle}-${trip.id}`} className="bg-white rounded p-2 m-4 mr-0 ml-0">
                      <Trip trip={trip} doShowPrice={brochure.doShowPricing} />
                    </div>
                  ))
                )}
                {sendBrochureRequestStatus !== SearchStatus.INITIAL
                    && brochure.trips.length === 0 && (
                      <div className="w-full text-center py-8 text-gray-500">
                        No trips found in the brochure.
                      </div>
                )}
              </>
            ) : (
              brochure.trips.map((trip) => (
                <div key={`trip-${trip.longTripTitle}-${trip.id}`} className="bg-white rounded p-2 m-4 mr-0 ml-0">
                  <Trip trip={trip} doShowPrice={brochure.doShowPricing} />
                </div>
              ))
            )}
          </div>
        </div>
      )}
      {brochure && (brochure.doAllowBook || isLoggedIn) && isBrochurePage && (
        <ModalSpinnerSaveTrip tripId={brochure.id} />
      )}
    </div>
  );

  return withSpinner(
    renderComponent,
    getBrochureStatus === SearchStatus.SEARCHING,
    `Searching ${displayLabel}...`,
  );
};

Brochure.propTypes = {
  id: PropTypes.string.isRequired,
};

export default Brochure;
